import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import {
  Badge,
  Box,
  Card,
  CardHeader,
  Checkbox,
  Divider,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemText,
  makeStyles,
  Typography,
} from "@material-ui/core";
import { EditRounded, ShoppingCart, } from "@material-ui/icons";
import { useStepper } from "../Stepper/hooks";
import { Stepper } from "../Stepper/Stepper";
import { Step } from "../Stepper/Step";
import { StepperControlFooter } from "../Stepper/StepperControlFooter";
import PermitContent from "./PermitContent";
import Text from "../Text/Text";
import PermitAddedModel from "../Modals/buyCitation/permitAddedModel";
import BuyPerimtsEditOrderModal from "../Modals/buypermits/BuyPermitsExitOrderModal";
import {
  editBuyPermitSelectedPermit,
  hideBuyPermitsExitOrderModal,
  hideBuyPermitThankYouModal,
  resetBuyPermitDraftOrder,
  setBuyPermitDraftOrder,
  setBuyPermitSelectedPermit,
  showAllowedVehicleAlertModal,
  showBuyPermitsExitOrderModal,
  updateBuyPermitVehicleList,
} from "../../store/buyPermits/action";

import { getCustomer } from "../../store/home/selector";
import { getUserContextData } from "../../store/login/selector";
import { showBuyTermAndCondition, } from "../../store/login/action";
import BuyTermAndCondition from "../Modals/buypermits/BuypermitTermsCondition";
import AllBuyPermitList from "../Modals/buypermits/AllBuyPermitList";
import { getProfileData } from "../../store/profile/selector";
import { setAddPermitSelectdate } from "../../store/addPermitText/action";
import AllowedVehicleAlertModal from "../Modals/buypermits/AllowedVehicleAlertModal";
import AlertModal from "../Modals/buypermits/AlertModal";
import {
  getCheckboxAgreementTextEditorDataAction,
  getNewPermitOrderDataAction,
  getOrderCompletePageEditorDataAction,
  getPaymentPageEditorDataAction,
  getReviewAndOrderEditorDataAction,
} from "../../store/profile/action";
import { getDashboardHtmlWithSession } from "../../store/dashboard/action";
import { driverPermitResion } from "../../store/permitList/selector";
import SameVehicleAlertModal from "../Modals/buypermits/SameVehicleAlertModal";
import DenyPermitRuleModal from "../Modals/buypermits/DenyPermitRuleModal";
import VehicleCheckboxList from "../VehicleCheckboxList/VehicleCheckboxList";

import "./page.css";
import { dateAtTimezone, nowAtTimezone } from "utils/date-utils";

const useStyles = makeStyles((theme) => ({
  p5: {
    padding: "5px",
    alignItems: "center",
    textAlign: "center",
  },
  p5permit: {
    padding: "7px",
    border: "1px solid gray",
    alignItems: "center",
    textAlign: "center",
    margin: "5px 0px 5px 5px",
  },

  rightGrid: {
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    right: "10%",
  },
  toolbarContainer: {
    marginBottom: "10px",
    position: "relative",
    padding: "10px",
  },
  rightIconsContainer: {
    position: "absolute",
    right: "20px",
    top: 0,
  },
  headinText: {
    color: theme.palette.primary.main,
    fontWeight: "600",
  },
  handleNextterms: {
    color: theme.palette.primary.main,
  },
  dflex: {
    display: "flex",
  },
  dflex1: {
    display: "flex",
    fontSize: "14px",
    LineHeight: "25px",
  },
  dflexpermit: {
    display: "flex",
    padding: 10,
    backgroundColor: "white",
    alignItems: "center",
  },
  dflexpermitright: {
    marginLeft: "5px",
  },
  secondContainer: {
    textAlign: "center",
  },

  availablevehiclescolor: {
    color: theme.palette.primary.main,
  },
  availablevehiclesHeading: {
    color: theme.palette.primary.main,
    marginLeft: "15px",
  },
  active: {
    background: "aliceblue",
  },
  thirdStepFirstDiv: {
    borderRadius: "5px",
    boxShadow: "0px 0px 3px 1px rgba(0,0,0,0.75)",
    width: "auto",
    marginRight: "10px",
  },
  vehicleCardHeader: {
    background: "#20419a",
    color: "white",
    padding: "5px 15px",
  },
  vehiclesUl: {
    listStyleType: "none",
    padding: 10,
    margin: 0,
    LineHeight: "25px",
    fontSize: "11px",
  },
  thirdStepFirstDivChild: {
    background: theme.palette.primary.main,
    padding: "4px",
    color: "white",
  },
  stepperPadding: {
    padding: "24px",
  },
  checkboxColor: {
    color: theme.palette.primary.main,
  },
  firstStepFirstChildMaindiv: {
    padding: "6px",
    width: "auto",
    color: "white",
    marginRight: "15px",
    height: "fit-content",
    border: "1px solid gray",
    borderRadius: 10,
    textAlign: "center",
  },
  firstStepFirstChild: {
    background: theme.palette.primary.main,
    padding: "4px",
    width: "auto",
    color: "white",
    borderRadius: "2px",
  },
  dflexterm: {
    display: "flex",
  },
  backgroundtheme: {
    color: theme.palette.primary.main,
  },
}));

export default function AddPermitPage(props) {
  const classes = useStyles();
  const { allPermit, handletoggleAddPermitPage, StylingItem, selectedDate, setSelectedDate } = props;

  const draftOrder = useSelector(
    (state) => state?.exitOrderReducer?.buyPermitDraftOrder
  );
  const [stepper, next, back, handleBack] = useStepper({ steps: 3, initialStep: draftOrder?.step });

  const [toggleAddedModel, settoggleAddedModel] = useState(false);
  const [addedPermitSnapshot, setAddedPermitSnapshot] = useState(null);

  const [orderList, setorderList] = useState([]);
  const [permitList, setPermitList] = useState([]);
  const [permit, setPermit] = useState([]);
  const [PhysicalPermit, setPhysicalPermit] = useState([]);
  const profileStore = useSelector(getProfileData);
  const [permitType, setPermitType] = useState(draftOrder?.permitType ?? "");
  const [VirtualPermit, setVirtualPermit] = useState([]);

  const [reasonForVisit, setReasonForVisit] = useState(draftOrder?.reasonForVisit ?? "");
  const [openDenyPermit, setOpenDenyPermit] = useState(false)

  const profileUpdateData = useSelector(
    (state) =>
      state?.profileState?.profileStateList?.endUserAccountEntity?.person
  );

  const allPermitError = useSelector(
    (state) => state.driverPermitListReducer.driverPermitListStateListError
  );

  const getPaymentMethodState = useSelector(
    (state) => state?.exitOrderReducer?.buyPermitPaymentMethods
  );

  const editPermitId = useSelector(
    (state) => state?.exitOrderReducer?.buyPemitEditVehicle
  );
  const selectedRegisteredVehicles = useSelector(
    (state) => state?.exitOrderReducer?.buyPermitRegisteredVehicleList
  );
  const driverViewOrderStateList = useSelector(
    (state) => state.driverViewOrderReducer.driverViewOrderStateList
  );

  const getBuyPermitSelectedPermitsState = useSelector(
    (state) => state?.exitOrderReducer?.buyPermitSelectedPermits
  );
  const [selectedPermitData, setSelectedPermitData] = useState(
    getBuyPermitSelectedPermitsState
  );

  const virtualPermitReason = useSelector(driverPermitResion);

  useEffect(() => {
    setSelectedPermitData(getBuyPermitSelectedPermitsState);
  }, [getBuyPermitSelectedPermitsState]);

  const [vehicleList, setVehicleList] = useState([]);

  const [selectedPermit, setSelectedPermit] = useState(draftOrder?.selectedPermit ?? []);
  const [defaultChecked, setDefaultChecked] = useState(draftOrder?.defaultChecked ?? false);

  const [vehicles, setVehicles] = useState(draftOrder?.vehicles ?? []);
  const [noOfAllowedPermit, setNoOfAllowedPermit] = useState(0);
  const [hasMaxPermitSalesRule, setHasMaxPermitSalesRule] = useState(false);
  const [isOpenAllowedVehicleAlertModal, setIsOpenAllowedVehicleAlertModal] = useState(false);
  const [isOpenAllowedSameVehicleAlertModal, setIsOpenAllowedSameVehicleAlertModal] = useState(false);
  const [isOpenAlertModal, setIsOpenAlertModal] = useState(false);
  const [msg, setMsg] = useState("");
  const [permitId, setPermitId] = useState();
  const customerName = useSelector(getCustomer);
  const [count, setCount] = useState(1);
  const [formDate, setFormDate] = useState(draftOrder?.formDate);
  const [defaultSameVehicle, setDefaultSameVehicle] = useState(false);
  const user = useSelector(getUserContextData);

  useEffect(() => {
    if (!editPermitId?.permit_id) return;
    const match =
      (Array.isArray(permitList) &&
        permitList.find((e) => e?.id === editPermitId.permit_id)) ||
      (Array.isArray(VirtualPermit) &&
        VirtualPermit.find((e) => e?.id === editPermitId.permit_id));
    if (match) setSelectedPermit(match);
  }, [editPermitId, permitList]);

  const CloseAlertModal = () => {
    setIsOpenAlertModal(false);
  };


  const validEndDate = (endDate, validDate) => {
    const isAfter = moment(formDate).add(validDate, "days").isAfter(endDate);
    if (!formDate) {
      return moment(endDate)?.format("MM/DD/YYYY")
    } else if (isAfter === false) {
      return moment(formDate).add(validDate, "days")?.format("MM/DD/YYYY")
    } else {
      return moment(endDate)?.format("MM/DD/YYYY")
    }
  }

  useEffect(() => {
    if (!Array.isArray(getPaymentMethodState)) return;

    const rule = getPaymentMethodState.find(
      (item) => item.ruleType === "MAX_NUMBER_PERMIT_SALES"
    );

    const hasDriverAttributes =
      profileStore?.endUserAccountEntity?.driverAttributes?.length > 0;

    if (hasDriverAttributes) {
      setHasMaxPermitSalesRule(!!rule);
      setNoOfAllowedPermit(rule?.ruleValues?.[0]);
    }
  }, [getPaymentMethodState]);

  const driverStatus =
    profileStore &&
    profileStore?.endUserAccountEntity?.driverAttributes?.filter(
      (item, index) => {
        if (item?.name === "Status") {
          return item;
        }
      }
    );

  const status = Array.isArray(driverStatus) && driverStatus[0]?.value;

  const nonExpiredPermits =
    Array.isArray(orderList) &&
    orderList?.filter((order, i) => {
      const now = nowAtTimezone(user.client.timezone);
      const expirationDate = dateAtTimezone(order?.lines[0]?.item?.validEndDate, user.client.timezone);

      if (expirationDate > now) {
        return order?.lines[0]?.item;
      }
    });

  const purchasedPermitListName = nonExpiredPermits?.map((elmt, ndx) => {
    return elmt?.lines;
  });

  const filteredPurchasedList = purchasedPermitListName?.map((prmt) => {
    // return prmt[0]?.item.id;
  });


  useEffect(() => {
    const filteredPermit = permit?.filter((item, i) => {
      if (filteredPurchasedList?.indexOf(item?.id) === -1) {
        return item;
      }
    });

    if (
      profileStore &&
      profileStore?.endUserAccountEntity?.driverAttributes?.length <= 0
    ) {
    } else {
      setPermitList(filteredPermit);
    }
  }, [permit, profileStore, getPaymentMethodState]);

  const permitsForGrid = useMemo(() => {
    const filteredPermit = permit?.filter((item, i) => {
      if (filteredPurchasedList?.indexOf(item?.id) === -1) {
        return item;
      }
    });

    if (
      status === "undefined" ||
      (profileStore &&
        profileStore?.endUserAccountEntity?.driverAttributes?.length <= 0)
    ) {
      return [];
    } else {
      return filteredPermit;
    }
  }, [permitList, profileStore, orderList, getPaymentMethodState]);

  //########################### Physical pmt start ########################
  const PhysicalPermitsForGrid = useMemo(() => {
    const filteredPermit2 =
      Array.isArray(PhysicalPermit) &&
      PhysicalPermit?.filter((item, i) => {
        return item;
      });

    if (
      status === "undefined" ||
      (profileStore &&
        profileStore?.endUserAccountEntity?.driverAttributes?.length <= 0)
    ) {
      return [];
    } else {
      return filteredPermit2;
    }
  }, [permitList, profileStore, getPaymentMethodState, orderList]);

  //########################### Physical pmt end ##########################
  const dispatch = useDispatch();

  const currentStep = stepper.current;
  useEffect(() => {
    dispatch(
      setBuyPermitDraftOrder({
        selectedPermit,
        defaultChecked,
        formDate,
        permitType,
        reasonForVisit,
        vehicles,
        step: currentStep,
      })
    );
  }, [
    dispatch,
    selectedPermit,
    defaultChecked,
    formDate,
    permitType,
    reasonForVisit,
    vehicles,
    currentStep,
  ]);


  useEffect(() => {
    dispatch(hideBuyPermitThankYouModal());
    setorderList(driverViewOrderStateList);
  }, [driverViewOrderStateList, dispatch]);


  /** get profile data from reducer  */

  const getBuyPermitsExitOrderModal = useSelector(
    (state) => state?.exitOrderReducer?.buyPermitsExitOrderModal
  );

  const addPermitText = useSelector(
    (state) => state?.profileState?.newOrderPermitPageEditorData
  );

  const [isOpenExitOrderModal, setExitOrderModal] = useState(
    getBuyPermitsExitOrderModal
  );


  useEffect(() => {
    setExitOrderModal(getBuyPermitsExitOrderModal);
  }, [getBuyPermitsExitOrderModal]);
  useEffect(() => {
    dispatch(getNewPermitOrderDataAction({ groupName: user?.user?.userGroup || profileStore?.permission }));
  }, [user]);


  const allowedVehicleModalState = useSelector(
    (state) => state?.exitOrderReducer?.buyPermitAllowedVehicleAlertState
  );
  const EndUserId = useSelector(
    (state) => state?.profileState?.profileStateList?.endUserAccountEntity?.id
  );


  useEffect(() => {
    setIsOpenAllowedVehicleAlertModal(allowedVehicleModalState);
  }, [allowedVehicleModalState, EndUserId]);


  useEffect(() => {
    setTimeout(() => {
      if (count === 1) {
        if (allPermitError && allPermitError[0] === "You are unable to purchase permits, you have pending unpaid citations on your records.") {
          setOpenDenyPermit(true);
        }
      }
      setCount(0);
    }, 2000)

    validEndDate();
  }, [allPermit, allPermitError])


  const handleSubmit = () => {
    setSelectedDate(formDate);
    dispatch(setAddPermitSelectdate(selectedDate))

    setAddedPermitSnapshot({ permit: selectedPermit, selectedDate: formDate });
    if (editPermitId.permit_id && editPermitId.permit_id !== 0) {
      dispatch(
        editBuyPermitSelectedPermit({
          permit: selectedPermit,
          vehicles: vehicles,
          editPermitId: editPermitId,
        })
      );
    } else {
      dispatch(
        setBuyPermitSelectedPermit({
          permit: { ...selectedPermit, tdate: formDate },
          vehicles: vehicles,
          reasonForVisit: reasonForVisit
        })
      );
    }
    dispatch(updateBuyPermitVehicleList([]));
    settoggleAddedModel(true);
    resetForm();
  };

  const handleAllowedVehicleAlertModal = (allwedNoVehicles) => {
    dispatch(showAllowedVehicleAlertModal(allwedNoVehicles));
  };

  const handleSelectVehicle = (e, vehicle) => {
    if (selectedPermit?.id) {
      for (const permitState of getBuyPermitSelectedPermitsState || []) {
        const isSamePermit =
          permitState?.permit?.id === selectedPermit?.id ||
          getBuyPermitSelectedPermitsState.length <= 1;

        const isSamePermitName =
          permitState?.permit?.name === selectedPermit?.name ||
          getBuyPermitSelectedPermitsState.length <= 1;

        if (isSamePermit) {
          if (isSamePermitName) {
            setIsOpenAllowedSameVehicleAlertModal(true);
          } else if (vehicle?.id) {
            const vehicleAlreadySelected = (permitState?.vehicles || []).some(
              (v) => v.id === vehicle.id
            );
            if (vehicleAlreadySelected) {
              setIsOpenAllowedSameVehicleAlertModal(true);
              setDefaultSameVehicle(true);
              e.target.checked = false;
            }
          }
        }
      }
    }

    if (vehicles?.length >= 2) {
      e.stopPropagation();
    }

    let tmpVehicles = [...vehicles];
    const exists = tmpVehicles.some((v) => v.id === vehicle.id);

    if (exists) {
      tmpVehicles = tmpVehicles.filter((v) => v.id !== vehicle.id);
    } else if (vehicles?.length < selectedPermit?.allowedNoVehicles) {
      tmpVehicles.push(vehicle);
    } else {
      e.target.checked = false;
      handleAllowedVehicleAlertModal(selectedPermit?.allowedNoVehicles);
    }

    setVehicles(tmpVehicles);
    dispatch(updateBuyPermitVehicleList(tmpVehicles));
  };

  const handleNext = () => {
    next(stepper.current);
  };

  const handleJump = (number) => {
    handleBack(number);
  };

  const handleToggleAddedModel = () => {
    settoggleAddedModel(!toggleAddedModel);
    handleBack(0);
  };

  const stylingVal = {
    backgroundColor: StylingItem && StylingItem.bodyColor,
    fontFamily: StylingItem && StylingItem.font,
    color: StylingItem && StylingItem.fontColor,
  };

  const handleBuyTermAndCondition = (e) => {
    const isChecked = e.target.checked;
    setDefaultChecked(isChecked);
    // Display the terms and conditions modal only when the checkbox is being changed from unchecked to checked
    isChecked && dispatch(showBuyTermAndCondition());
  };

  useEffect(() => {
    if (profileUpdateData) {
      profileUpdateData.vehicles = profileUpdateData.vehicles.filter(item => !item.inactive)
      setVehicleList(profileUpdateData);
    }
    validEndDate();
  }, []);


  const handleSelectPermit = (permitId) => {
    // Called with no args from a mount effect; without a real id this would
    // clobber a restored/in-progress selection with undefined, so bail out.
    if (permitId == null) return;
    const maxPermitRule = Array.isArray(getPaymentMethodState)
      ? getPaymentMethodState.find(item => item?.ruleType === "MAX_NUMBER_PERMIT_SALES")
      : undefined;

    if (
      maxPermitRule &&
      ((nonExpiredPermits?.length || 0) + (selectedPermitData?.length || 0)) >= maxPermitRule?.ruleValues[0]
    ) {
      const message = "You are only allowed to order " +
        maxPermitRule?.ruleValues[0] +
        " permit";
      const messages = "You are only allowed to order " +
        maxPermitRule?.ruleValues[0] +
        " permits";

      const permitLimit = maxPermitRule?.ruleValues[0] < 2 ? message : messages;
      setMsg(permitLimit);
      setIsOpenAlertModal(true);
    } else {
      setSelectedPermit(
        permitList && permitList.find((e) => e?.id === permitId)
      );
    }
  };

  //######################## Physical Permit start ################################
  const handleSelectPermit2 = (permitId) => {
    // Called with no args from a mount effect; without a real id this would
    // clobber a restored/in-progress selection with undefined, so bail out.
    if (permitId == null) return;
    const maxPermitRule = Array.isArray(getPaymentMethodState)
      ? getPaymentMethodState.find(itm => itm?.ruleType === "MAX_NUMBER_PERMIT_SALES")
      : undefined;

    if (
      maxPermitRule &&
      ((nonExpiredPermits?.length || 0) + (selectedPermitData?.length || 0)) >= maxPermitRule?.ruleValues[0]
    ) {
      const message =
        "You are only allowed to order " +
        (maxPermitRule?.ruleValues[0]) +
        " permit";
      const messages =
        "You are only allowed to order " +
        (maxPermitRule?.ruleValues[0]) +
        " permits";

      const permitMessage = maxPermitRule?.ruleValues[0] < 2 ? message : messages
      setMsg(permitMessage);
      setIsOpenAlertModal(true);
    } else {
      setSelectedPermit(
        Array.isArray(PhysicalPermit) &&
        PhysicalPermit.find((e) => e.id === permitId)
      );
    }
  };

  useEffect(() => {
    handleSelectPermit2();
    handleSelectPermit();
  }, [dispatch]);

  //######################## Physical Permit End ##################################

  const validation = () => {
    let isValidate = true;
    if (stepper?.current === 0) {
      if (selectedPermit && selectedPermit?.permitType && selectedPermit?.permitType?.includes("STD_PERMIT")) {
        if (selectedPermit?.id && defaultChecked) {
          isValidate = false
        }
      } else if (selectedPermit?.id && defaultChecked
        && virtualPermitReason?.reasonForVisitIsRequired && reasonForVisit !== "") {
        isValidate = false;
      } else if (!virtualPermitReason?.reasonForVisitIsRequired && selectedPermit?.id && defaultChecked) {
        isValidate = false;
      }
    }

    if (stepper.current === 1) {
      if (vehicles.length > 0) {
        if (defaultSameVehicle === false) {
          isValidate = false;

        }
      }
    }
    if (stepper.current === 2) {
      isValidate = false;
    }
    return isValidate;
  };


  const cancelShowBuyPermitsExitOrderModal = () => {
    dispatch(showBuyPermitsExitOrderModal());
  };

  const CancelBuyPermitsExitOrderModal = useCallback((type) => {
    dispatch(hideBuyPermitsExitOrderModal());
  });
  const getMessage = () => {
    if (PhysicalPermit.length < 1) {
      if (VirtualPermit.length < 1) {
        return "No Permits Available for Purchase"
      } else {
        return "Permit(s) available for purchase"
      }
    } else {
      return "Permit(s) available for purchase"
    }
  }


  function resetForm() {

    handleBack(0)

    setSelectedPermit([]);

    setDefaultChecked(false);

    setPermitType("");
    setFormDate(undefined);
    setReasonForVisit("");

    setIsOpenAllowedVehicleAlertModal(false)
    setIsOpenAllowedSameVehicleAlertModal(false)
    setVehicles([])

    dispatch(resetBuyPermitDraftOrder());
  }

  const ConfirmBuyPermitsExitOrderModal = useCallback((type) => {
    dispatch(hideBuyPermitsExitOrderModal());
    resetForm();
  });

  useEffect(() => {
    dispatch(getDashboardHtmlWithSession({ customerName }));
    if (user?.user?.userGroup) {
      dispatch(getCheckboxAgreementTextEditorDataAction(user?.user?.userGroup));
      dispatch(getPaymentPageEditorDataAction(user?.user?.userGroup));
      dispatch(getOrderCompletePageEditorDataAction(user?.user?.userGroup));
      dispatch(getReviewAndOrderEditorDataAction(user?.user?.userGroup));
    }
  }, [user]);


  const handlePermitClick = (ele) => {
    setPermitType("EFP")
    setPermitId(ele)
  }


  ////##############################Physical Permit start ######################
  const getPermitList2 = () => {
    if (!Array.isArray(PhysicalPermitsForGrid)) return null;

    return PhysicalPermitsForGrid.map((item, index) => (
      <React.Fragment key={`permit-${item.id}-${index}`}>
        <ListItem
          divider
          className={`wrap ${classes.vehicleRow} ${selectedPermit?.id === item?.id ? classes.active : ""}`}
          spacing
          tabIndex={0}
          role="button"
          aria-pressed={selectedPermit?.id === item?.id}
          onClick={() => handleSelectPermit2(item.id)}
          onKeyDown={(event) => {
            if (event.key === "Enter" || event.key === " ") {
              event.preventDefault();
              handleSelectPermit2(item.id);
            }
          }}
        >
          <ListItemText className="step-form">
            <div className="d-flex contentwrapper">
              <PermitContent permit={item}/>

              <div className="text-left">
                <p className={classes.headinText}>
                  {item?.name} &nbsp; &nbsp;
                </p>

                <p>
                  {`Valid from ${moment(item?.validStartDate).format("MM/DD/YYYY")} to ${moment(item?.validEndDate).format("MM/DD/YYYY")}`}
                </p>
                <p>${item?.price?.toFixed(2)}</p>
                <p>{item?.allowedNoVehicles} Vehicle limit</p>
              </div>
            </div>
          </ListItemText>
        </ListItem>
      </React.Fragment>
    ));
  };

  ////##############################Physcial permit end ########################

  ////############################## Virtual Permit Start ####################//////
  const getPermitList = () => {
    let filterPermit = permitsForGrid?.filter((item) => item?.id === permitId?.id)

    return (
      filterPermit && filterPermit?.map((item, index) => (
        <>
          <ListItem
            divider
            key={index}
            className={`${classes.activeVehicleRow} ${classes.vehicleRow}`}
            spacing
            tabIndex="0"
            onKeyDown={(event) => {
              if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                handleSelectPermit(item?.id);
              }
            }}
            onClick={() => {
              handleSelectPermit(item.id);
            }}
            className={
              selectedPermit && selectedPermit?.id === item?.id
                ? classes.active
                : ""
            }
          >
            <ListItemText className="step-form">
              <>
                <div className="d-flex contentwrapper">
                  <PermitContent permit={item}/>

                  <div className="text-left">
                    <p className={classes.headinText}>
                      {item?.name} &nbsp; &nbsp;
                    </p>

                    <p>${item?.price?.toFixed(2)}</p>
                    <p>{item?.allowedNoVehicles} Vehicle limit</p>
                  </div>
                </div>
              </>
            </ListItemText>
          </ListItem>
        </>
      ))
    )
  }

  ////############################## Virtual Permit End ######################//////

  ///////////////////////////////get all Date between two Date//////////////////////////////////////////////
  let getDaysBetweenDates = function (startDate, endDate) {
    let now = startDate.clone(),
      dates = [];

    while (now.isSameOrBefore(endDate)) {
      dates.push(now.format("MM/DD/YYYY"));
      now.add(1, "days");
    }
    return dates;
  };

  ///////////////////////////////End get all Date between two Date//////////////////////////////////////////////

  const handleDateChange = (e) => {

    setFormDate(e.target.value)

    const filteredPermit = allPermit?.filter((item, i) => {
      if (filteredPurchasedList?.indexOf(item?.id) === -1) {
        return item;
      }
    });

    setPermit([
      ...filteredPermit.filter((objItem) => {
        if (objItem?.permitType === "EFP") {
          let dateList = getDaysBetweenDates(
            moment(objItem?.salesStartDate || objItem?.validStartDate),
            moment(objItem?.salesEndDate || objItem?.validEndDate)
          );

          let selectedDateNew = moment(e.target.value)?.format("MM/DD/YYYY");
          if (dateList?.includes(selectedDateNew)) {
            return objItem;
          } else {
            return null;
          }
        } else {
          if (
            objItem?.validStartDate === e.target.value &&
            objItem?.permitType === permitType
          ) {
            return objItem;
          } else {
            return null;
          }
        }
      }),
    ]);
  };


  const handleReasonForVisit = (e) => {
    setReasonForVisit(e.target.value)
  }

  useEffect(() => {
    const filteredPermit = allPermit?.filter((item, i) => {
      if (filteredPurchasedList?.indexOf(item?.id) === -1) {
        return item;
      }
    });

    setPhysicalPermit([
      ...filteredPermit.filter((objItem) => {
        if (objItem?.permitType === "STD_PERMIT") {
          return objItem;
        } else {
          return null;
        }
      }),
    ]);

    //Virtual Permit filter

    setVirtualPermit([
      ...filteredPermit.filter((objItem) => {
        if (objItem?.permitType === "EFP") {
          let x = { ...objItem, test: "12" }
          return objItem;
        } else {
          return null;
        }
      }),
    ]);

  }, [allPermit, orderList]);

  useEffect(() => {
    const filteredPermit = allPermit?.filter((item, i) => {
      if (filteredPurchasedList?.indexOf(item?.id) === -1) {
        return item;
      }
    });

    setPermit([
      ...filteredPermit.filter((objItem) => {
        if (objItem?.permitType === "EFP") {
          let dateList = getDaysBetweenDates(
            moment(objItem?.salesStartDate || objItem?.validStartDate),
            moment(objItem?.salesEndDate || objItem?.validEndDate)
          );
          let selectedDateNew = moment(selectedDate)?.format("MM/DD/YYYY");
          if (dateList?.includes(selectedDateNew)) {
            return objItem;
          } else {
            return null;
          }
        } else {
          if (
            objItem?.validStartDate === selectedDate &&
            objItem?.permitType === permitType
          ) {
            return objItem;
          } else {
            return null;
          }
        }
      }),
    ]);
  }, [selectedDate]);

  useEffect(() => {
    setPermit([]);
  }, [permitType, PhysicalPermit]);


  let virtualPmt = VirtualPermit.find((ele) => {
    if (ele?.permitType === "EFP") return ele;
  });


  let dailyPmt = allPermit.find((ele) => {
    if (ele?.permitType === "DAILY") return ele;
  });

  return (
    <div style={stylingVal && stylingVal} className="permit-page-wrapper permit_mrb">

      <div className="header-wrapper">
        <div className="d-flex align-items-center justify-content-between">
          <div className="auth-heading makeStyles-tableheader-179" style={{ color: "#3f51b5" }}>

            <h1 className="m-0" title="New permit order">New permit order</h1>
          </div>
          <div>
            <IconButton tabIndex="0" title="ShoppingCart" onClick={(e) => handletoggleAddPermitPage("view")}>
              <Badge color="primary" badgeContent={selectedPermitData?.length || 0}>
                <ShoppingCart className={classes.backgroundtheme}/>
              </Badge>
            </IconButton>
          </div>
        </div>
        <Divider/>
      </div>

      <Grid container spacing={3} style={{ marginTop: 0 }}>
        <Grid item xxl={8} xl={8} lg={8} md={12} sm={12} xs={12}>
          <Stepper activeStep={stepper.current} orientation="vertical">
            {/* ##################-----physical Permit start ----#####################*/}
            <Step className="iText" align="left" title="Select Permit">
              <List>
                <li style={{ listStyle: "none" }}>{getMessage()}</li>
                {getPermitList2()}
              </List>
              {/* ###################---physical Permit end----#############33 */}
              <div
                style={{
                  marginBottom: "20px",
                  marginLeft: "5px",
                  overflowX: "auto",
                  display:
                    selectedPermit?.permitType === "STD_PERMIT"
                      ? "none"
                      : "flex",
                }}
                className={
                  selectedPermit?.permitType === "STD_PERMIT"
                    ? "widthFlex"
                    : "noFlax"
                }
              >
                {dailyPmt?.name === undefined ? (
                  ""
                ) : (
                  <span
                    role="button"
                    tabIndex={0}
                    style={
                      permitType === "DAILY"
                        ? { backgroundColor: "#D3D3D3", cursor: "pointer" }
                        : { backgroundColor: "", cursor: "pointer" }
                    }
                    onClick={(e) => setPermitType("DAILY")}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        setPermitType("DAILY");
                      }
                    }}
                  >
                    <div className=" text-center boxOuter2">
                      <div className="colorBox">
                        <div>
                          <p className="contentText fw-900">{dailyPmt?.name}</p>
                        </div>
                      </div>
                    </div>
                  </span>
                )}

                {/* virtual permit show */}
                {VirtualPermit && VirtualPermit?.map((elee) => elee?.name === undefined ? ("") :

                  <span
                    role="button"
                    tabIndex={0}
                    onKeyDown={(event) => {
                      if (event.key === "Enter" || event.key === " ") {
                        event.preventDefault();
                        handlePermitClick(elee);
                      }
                    }}
                    onClick={(e) => handlePermitClick(elee)}

                    style={
                      elee.permitType === "EFP"
                        ? { backgroundColor: "#D3D3D3", cursor: "pointer" }
                        : { backgroundColor: "", cursor: "pointer" }
                    }
                  >
                    <div className=" text-center boxOuter2">
                      <div className="colorBox">
                        <div style={{ width: "180px" }} className="permitN">
                          <p
                            className="contentText fw-900"
                            style={{ paddingBottom: "20px" }}
                          >
                            {elee?.name}<br/>

                            {`Valid from ${moment(elee?.validStartDate)?.format(
                              "MM/DD/YYYY"
                            )} to ${moment(elee?.validEndDate)?.format("MM/DD/YYYY")}`}
                          </p>
                        </div>
                      </div>
                    </div>
                  </span>
                )
                }

              </div>
              {virtualPmt?.name === undefined && dailyPmt?.name === undefined ? (
                ""
              ) : (
                <>

                  <div
                    className="formGroup dateFlex"
                    style={{
                      display:
                        selectedPermit?.permitType === "STD_PERMIT" ||
                        permitType === ""
                          ? "none"
                          : "flex",
                    }}
                  >
                    <label htmlFor="selectedDate">Select Date</label>
                    <input
                      type="date"
                      id="selectedDate"
                      name="selectedDate"
                      value={formDate}
                      onChange={handleDateChange}
                      pattern="\d{4}-\d{2}-\d{2}"
                      min={new Date().toISOString().split("T")[0]}
                    />
                    <br/>
                    {virtualPermitReason?.reasonForVisitIsEnabled ?
                      <div className="formGroup">
                        <label className="margin-bottomset">
                          Reason for visit :{" "}
                        </label>
                        <textarea
                          id="reasonForVisit"
                          name="reasonForVisit"
                          value={reasonForVisit}
                          onChange={handleReasonForVisit}
                          fullWidth
                          rows={3}
                        ></textarea>
                      </div>
                      : ""}
                  </div>

                </>
              )}
              <div
                className={classes.vehicleDiv}
                style={{
                  position: "relative",
                  marginTop: "10px",
                  marginBottom: "10px",
                }}
              >
                <div
                  style={{
                    display:
                      selectedPermit?.permitType === "STD_PERMIT"
                        ? "none"
                        : "flex",
                  }}
                >
                  <List
                    style={{ display: permit?.length > 0 ? "block" : "none" }}
                  >
                    {getPermitList()}
                  </List>
                </div>
                <div
                  style={{
                    color: "red",
                    display:
                      selectedPermit?.permitType === "STD_PERMIT"
                        ? "none"
                        : "flex",
                  }}
                >
                  {permitType === "DAILY" && permit?.length <= 0
                    ? selectedDate !== ""
                      ? "Daily Permit Not Found"
                      : ""
                    : ""}
                  {permitType === "EFP" && permit?.length <= 0
                    ? selectedDate !== ""
                      ? "Virtual Permit Not Found"
                      : ""
                    : ""}
                </div>
              </div>

              {allPermit?.length > 0 ? (
                <div className={classes.dflexterm}>
                  <Checkbox
                    checked={defaultChecked}
                    color="primary"
                    onClick={handleBuyTermAndCondition}
                    id="parking-rules-and-regulations"
                  />
                  <p className={classes.handleNextterms}>
                    <label htmlFor="parking-rules-and-regulations" style={{ padding: 10 }}>
                      Parking rules and regulations
                    </label>
                  </p>
                </div>
              ) : (
                ""
              )
              }
            </Step>
            <Step title="Choose vehicle">
              <div className="centerBox1">
                <div className="box-select">
                  <Typography variant="p">
                    Select up to {selectedPermit?.allowedNoVehicles} Vehicles
                  </Typography>
                  <Box className="secondContainerChild">
                    <h2 className={classes.availablevehiclesHeading}>
                      <b> Available Vehicles</b>
                    </h2>
                    <Divider/>
                    <VehicleCheckboxList
                      vehicleList={vehicleList?.vehicles}
                      vehicles={vehicles}
                      handleSelectVehicle={handleSelectVehicle}
                    />
                  </Box>
                </div>
              </div>
            </Step>
            <Step
              align="left"
              title="Review and Add"
              style={{ paddingLeft: 0 }}
            >
              <p>
                <Text style={{ marginBottom: 10 }}>
                  Please confirm your entries below, if everything looks good
                  ,select <b>"Add"</b>
                </Text>
              </p>
              <Grid container spacing={3}>
                <Grid
                  item
                  xxl={7}
                  xl={7}
                  lg={7}
                  md={6}
                  sm={12}
                  xs={12}
                  className="w1000"
                >
                  <Card
                    className={classes.thirdStepFirstDiv}
                    style={{ marginRight: 0 }}
                  >
                    <CardHeader
                      className={classes.vehicleCardHeader}
                      action={
                        <>
                          <IconButton tabindex="0"
                                      title="Pencil Button">
                            <EditRounded
                              style={{ color: "white", marginTop: 8 }}
                              onClick={(e) => handleJump(0)}
                            />
                          </IconButton>
                        </>
                      }
                      title="Permit"
                    ></CardHeader>
                    <>
                      <div
                        className="d-flex contentwrapper"
                        style={{ padding: 10 }}
                      >
                        <PermitContent permit={selectedPermit}/>
                        <div className="text-left">
                          <p className={classes.headinText}>
                            {selectedPermit?.name} &nbsp; &nbsp;{" "}
                          </p>

                          <p>
                            Good from{" "}
                            {moment(formDate ? formDate : selectedPermit?.validStartDate)?.format(
                              "MM/DD/YYYY"
                            )}{" "}
                            to{" "} {validEndDate(selectedPermit?.validEndDate, selectedPermit?.validDays)}

                          </p>
                          <tr>
                            <th>Price :</th>
                            <th>
                              <p>${selectedPermit?.price?.toFixed(2)}</p>
                            </th>
                          </tr>
                          <tr>
                            <th>Fee :</th>
                            <th>
                              <p>${selectedPermit?.fee?.toFixed(2)}</p>
                            </th>
                          </tr>

                          <p>
                            {selectedPermit?.allowedNoVehicles} Vehicle Limit
                          </p>
                        </div>
                      </div>
                    </>
                  </Card>
                </Grid>
                <Grid
                  xxl={5}
                  xl={5}
                  lg={5}
                  md={6}
                  sm={12}
                  xs={12}
                  className="w1000"
                  style={{ marginTop: 14 }}
                >
                  <Box
                    className={classes.thirdStepFirstDiv}
                    style={{ marginleft: 10 }}
                  >
                    <Card className="contentwrap">
                      <CardHeader
                        className={classes.vehicleCardHeader}
                        action={
                          <>
                            <IconButton tabindex="0"
                                        title="Pencil Button">
                              <EditRounded
                                style={{ color: "white", marginTop: 8 }}
                                onClick={(e) => handleJump(1)}
                              />
                            </IconButton>
                          </>
                        }
                        title="Vehicles"
                      ></CardHeader>
                      <ul className={classes.vehiclesUl}>
                        {vehicles &&
                          vehicles?.map((item, index) => {
                            return (
                              <>
                                <li key={index} spacing>
                                  <div className={classes.dflex1}>
                                    <div className="min-w80">
                                      <b>Vehicles {index + 1}</b> :
                                    </div>
                                    <div className={classes.headinText}>
                                      <p>
                                        {`${item?.year} ${item?.color} ${item?.make?.name} ${item?.model} `}
                                      </p>

                                      <p>
                                        {item.licensePlate.state.code}{""} - {item?.licensePlate?.number} VIN :{" "}
                                        {item?.vin || "N/A"}
                                      </p>
                                    </div>
                                  </div>
                                  <Divider/>
                                </li>
                              </>
                            );
                          })}
                      </ul>
                    </Card>
                  </Box>
                </Grid>
              </Grid>
            </Step>
            <div className="stepperPadding">
              <StepperControlFooter
                submitText="Add"
                stepper={stepper}
                onNext={handleNext}
                onCancel={cancelShowBuyPermitsExitOrderModal}
                onBack={back}
                disableNext={validation()}
                onSubmit={handleSubmit}
                disabled={
                  hasMaxPermitSalesRule &&
                  ((nonExpiredPermits?.length || 0) + (selectedPermitData?.length || 0)) >= noOfAllowedPermit
                }
              />
            </div>
          </Stepper>
        </Grid>
        {stepper.current === 2 ? (
          ""
        ) : (
          <Grid
            item
            xxl={4}
            xl={4}
            lg={4}
            md={12}
            sm={12}
            xs={12}
            onClick={() => setSelectedPermit([])}
          >
            <Box
              className=""
              style={{
                background: "white",
                boxShadow: "0 .125rem .25rem rgba(0,0,0,.075)",
                display: `${addPermitText && addPermitText ? "block" : "none"}`,
              }}
            >
              {addPermitText && addPermitText.text !== "" ? (
                <div
                  className="ql-editor"
                  style={{
                    color: "black",
                    fontFamily: `${addPermitText && addPermitText?.includes("ql-font-lucinda") ? "Lucinda Sand Unicode" : addPermitText && addPermitText?.includes("ql-font-georgia") ? "Georgia" : addPermitText && addPermitText?.includes("ql-font-comic") ? "Comic Sans MS"
                      : addPermitText && addPermitText?.includes("ql-font-courier") ? "Courier New" : addPermitText && addPermitText?.includes("ql-font-tahoma") ? "Tahoma" : addPermitText && addPermitText?.includes("ql-font-times") ? "\"Times New Roman\""
                        : addPermitText && addPermitText?.includes("ql-font-trebuchet") ? "Trebuchet MS" : addPermitText && addPermitText?.includes("ql-font-verdana") ? "Verdana"
                          : addPermitText && addPermitText?.includes("ql-font-helvetica") ? "Helvetica" : addPermitText && addPermitText?.includes("ql-font-monospace") ? "Monospace"
                            : addPermitText && addPermitText?.includes("ql-font-roboto") ? "roboto" : "Arial"}`
                  }}
                  dangerouslySetInnerHTML={{ __html: addPermitText }}
                />
              ) : (
                <></>
              )}
            </Box>
          </Grid>
        )}
      </Grid>


      <PermitAddedModel
        vehicles={vehicles}
        selectedPermit={selectedPermit}
        open={toggleAddedModel}
        onClose={handleToggleAddedModel}
        handleToggleAddPermitPage={handletoggleAddPermitPage}
        selectedDate={addedPermitSnapshot?.selectedDate}
        d={addedPermitSnapshot?.permit}
        setVehicles={setVehicles}
        setvehicleList={setVehicleList}
      />
      <BuyPerimtsEditOrderModal
        isOpenExitOrderModal={isOpenExitOrderModal}
        CancelBuyPermitsExitOrderModal={CancelBuyPermitsExitOrderModal}
        ConfirmBuyPermitsExitOrderModal={ConfirmBuyPermitsExitOrderModal}
      />
      <BuyTermAndCondition/>
      <AllBuyPermitList
        selectedPermit={selectedPermit}
        profileUpdateData={profileUpdateData}
        permitList={permitList}
        handleSelectPermit={handleSelectPermit}
      />
      <AllowedVehicleAlertModal
        isOpenAllowedVehicleAlertModal={isOpenAllowedVehicleAlertModal}
        vehicleLimit={selectedPermit}
        onBack={back}
      />
      <SameVehicleAlertModal
        isOpenAllowedSameVehicleAlertModal={isOpenAllowedSameVehicleAlertModal}
        setIsOpenAllowedSameVehicleAlertModal={setIsOpenAllowedSameVehicleAlertModal}
        setDefaultsameVehicle={setDefaultSameVehicle}
        setvehicles={setVehicles}
      />
      <AlertModal
        isOpenAlertModal={isOpenAlertModal}
        CloseAlertModal={CloseAlertModal}
        data={msg}
      />
      <DenyPermitRuleModal
        openDenyPermit={openDenyPermit}
        setOpenDenyPermit={() => setOpenDenyPermit(false)}/>
    </div>
  );
}